// A conta anônima de antes tentou guardar a conta com um Google que já tem conta no Truco de 6. Entrar nessa conta
// troca de conta: o progresso da conta anônima fica para trás, e o aviso vem antes do botão.
import { useState } from 'react';
import { conta } from '../comum/conta.ts';
import { medir } from '../comum/medicao.ts';
import { LogoGoogle } from './Entrada.tsx';

export function JaTemConta({ aoFechar }: { aoFechar: () => void }) {
  const [erro, setErro] = useState<string | null>(null);
  return (
    <div className="dialogo-fundo">
      <div className="dialogo" role="alertdialog" aria-modal="true" aria-labelledby="ja-tem-conta" aria-describedby="ja-tem-conta-aviso">
        <h2 id="ja-tem-conta">Esse Google já tem conta no Truco de 6</h2>
        <p id="ja-tem-conta-aviso">Você pode entrar nessa conta. O progresso desta aqui não vai junto: o apelido, o rosto e as partidas dela ficam para trás.</p>
        <button className="google" onClick={() => {
          setErro(null);
          medir('login', { method: 'google', origem: 'ja_tem_conta' });
          conta.entrarComGoogle(location.origin + '/').catch((e: Error) => setErro(e.message));
        }}><LogoGoogle />Entrar nessa conta</button>
        <button className="btn2 largo" onClick={aoFechar}>Escolher outro Google</button>
        {erro && <p className="erro" role="alert">{erro}</p>}
      </div>
    </div>
  );
}
